import getErrorMessage from '../../../common/utils/getErrorMessage';
import Analytics from '../../../common/utils/analyticsUtil';
import notifyUser from '../../../common/utils/notifyUser';
import { NOTIFICATION_STATUS } from '../../../common/constants';
import signOutCleanUp from './signOutCleanUp';
const signOut = payload => dispatch => {
  const { onSuccess, onError } = payload;
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/onboard/users/sign_out',
      method: 'POST',
      headers: {
                'oyo-intent': 'signOut',
      }
    },
    onSuccess: ({ data, store, next, actions }) => {
      Analytics.unregisterProperties();
      store.dispatch(signOutCleanUp(payload, data));
      dispatch({ type: 'RESET_FILTERS' });
      dispatch({ type: 'CLEAR_FETCHING_FEEDBACK_DATA' });
      dispatch({ type: 'CLEAR_FEEDBACK_WIDGETS' });
      onSuccess && onSuccess();
    },
    onError: ({ store, error }) => {
      Analytics.setUserId(null);
      notifyUser({
        store,
        id: 'singout_error',
        status: NOTIFICATION_STATUS.ERROR,
        toast_text: getErrorMessage(error)
      });
      onError && onError(getErrorMessage(error));
    }
  });
}

export default signOut;
